function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 9.5L18 11V17L12 20L6 17V11L9 9.5",
  stroke: "#ffffff",
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14L11.7764 14.4472C11.9172 14.5176 12.0828 14.5176 12.2236 14.4472L12 14ZM5.77639 11.4472L11.7764 14.4472L12.2236 13.5528L6.22361 10.5528L5.77639 11.4472ZM12.2236 14.4472L18.2236 11.4472L17.7764 10.5528L11.7764 13.5528L12.2236 14.4472Z",
  fill: "#ffffff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16L12 14",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10L12 4",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15 7L9 7",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var SvgSources = function SvgSources(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSources, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sources.140edd14.svg";
export { ForwardRef as ReactComponent };